@if (serviceordre) {
  <div class="page__nav">
    <app-back-button [text]="'Tilbage'" [altLink]="'/ordre'" [altText]="'Ordre overblik'" idparameter="serviceordreNo"></app-back-button>
    <div class="contract__info">
      <span>Ordre</span>
      <mat-icon [svgIcon]="getProductIcon(serviceordre)" [matTooltip]="getProductIcon(serviceordre) | titlecase"></mat-icon>
      <div class="icon-with-text">
        {{ serviceordre.serviceordreNo }}
        <app-copy class="margin--left-xs" [content]="serviceordre.serviceordreNo" [matTooltip]="'Kopiér service nummer'"></app-copy>
      </div>
    </div>
    <div class="data">
      <div class="data__lbl">Serviceinterval</div>
      <div class="data__val">
        {{ serviceordre.serviceintervalStart | date : 'dd.MM.yyyy' }} - {{ serviceordre.serviceintervalEnd | date : 'dd.MM.yyyy' }}
      </div>
    </div>
    <div class="data">
      <div class="data__lbl">Deadline</div>
      <div class="data__val">
        {{ serviceordre.deadline | date : 'dd.MM.yyyy' }}
      </div>
    </div>
    <div class="data">
      <div class="data__lbl">Leveringsdato</div>
      <div class="data__val">
        {{ serviceordre.leveringsdato | date : 'dd.MM.yyyy' }}
      </div>
    </div>
    <div class="data">
      <div class="data__lbl">Opgave</div>
      <div class="data__val">{{ serviceordre.opgaveDisplayText }}</div>
    </div>
    <div class="data">
      <div class="data__lbl">Status</div>
      <div class="data__val">
        {{ serviceordre.serviceordreStateUserText }}
      </div>
    </div>
    @if (serviceordre.partner) {
      <div class="data">
        <div class="data__lbl">Partner</div>
        <div class="data__val">
          <button type="button" (click)="openPartnerInfo()" class="btn-icon blue">
            {{ serviceordre.partner.name }}
          </button>
        </div>
      </div>
    }
    @if (serviceordre.partner.id !== serviceordre.originalPartnerId) {
      <div class="data">
        <div class="data__lbl">Oprindelig partner</div>
        <div class="data__val">{{ serviceordre.originalPartnerName }}</div>
      </div>
    }
    @if (serviceordre.bookingId) {
      <div class="data">
        <div class="data__lbl">Bookingnr</div>
        <div class="data__val">{{ serviceordre.bookingId }}</div>
      </div>
    }
    @if (serviceOrdreAfregning?.vognnr) {
      <div class="data">
        <div class="data__lbl">Vognnr</div>
        <div class="data__val">{{ serviceOrdreAfregning?.vognnr }}</div>
      </div>
    }
    @if (serviceOrdreAfregning?.teknikernr) {
      <div class="data">
        <div class="data__lbl">Teknikernr</div>
        <div class="data__val">{{ serviceOrdreAfregning?.teknikernr }}</div>
      </div>
    }
    <hr />
    <mat-selection-list #subpage [multiple]="false" [hideSingleSelectionIndicator]="true" (selectionChange)="selectionChanged($event)">
      <mat-list-option [selected]="page == 'Detaljer'" value="Detaljer">Detaljer</mat-list-option>
      <mat-list-option [selected]="page == 'Historik'" value="Historik">Historik</mat-list-option>
      <mat-list-option [selected]="page == 'Rapporter'" value="Rapporter">Rapporter</mat-list-option>
    </mat-selection-list>
    <hr class="bottom-sep" />
    <app-kunde-info [kunde]="$safeNavigationMigration(serviceAftale?.kunde)"></app-kunde-info>
    <div class="page__nav-bottom"></div>
  </div>
  <div class="topbar topbar--has-submenu">
    <div
      class="timestamp"
      title="Ordre sidst redigeret {{
        serviceordre.modifiedOn | amLocale : 'da' | amCalendar : { sameElse: 'DD.MM.YYYY [kl.] HH.mm' }
      }} af {{ serviceordre.modifiedBy }}"
      >
      <strong>Ændret:&nbsp;</strong>
      {{ serviceordre.modifiedOn | amLocale : 'da' | amCalendar : { sameElse: 'DD.MM.YYYY [kl.] HH.mm' } }}
      @if (!serviceOrdreAfregning?.automaticApprovedForAccounting) {
        <mat-icon
          [matTooltip]="serviceordre.modifiedBy"
          class="cursor-help"
          svgIcon="avatar"
        ></mat-icon>
      }
      @if (serviceOrdreAfregning?.automaticApprovedForAccounting) {
        <mat-icon
          [matTooltip]="serviceordre.modifiedBy + ' - Automatisk godkendt'"
          class="cursor-help"
          svgIcon="avatar-system"
        ></mat-icon>
      }
    </div>
    <div
      class="timestamp"
      title="Ordre oprettet {{ serviceordre.createdOn | amLocale : 'da' | amCalendar : { sameElse: 'DD.MM.YYYY [kl.] HH.mm' } }} af {{
        serviceordre.createdBy
      }}"
      >
      <strong>Oprettet:&nbsp;</strong>
      {{ serviceordre.createdOn | amLocale : 'da' | amCalendar : { sameElse: 'DD.MM.YYYY [kl.] HH.mm' } }}
      <mat-icon [matTooltip]="serviceordre.createdBy" class="cursor-help" svgIcon="avatar"></mat-icon>
    </div>
    <div class="timestamp">
      <strong>Kilde:&nbsp;</strong>
      {{ serviceordre.kilde | serviceordreKilde }}
    </div>
    <div class="topbar__actions">
      <app-opfoelgning-action
        [opfoelgningList]="serviceordre.opfoelgningList"
        [serviceordre]="serviceordre"
        (opfoelgningChange)="onOpfoelgningChanged($event)"
        [entityNo]="serviceordre.serviceordreNo"
      ></app-opfoelgning-action>
      @if (page == 'Historik') {
        <app-select-filter
          [filterOptions]="auditHistoryTypesKeys"
          (filterChange)="selectedAuditHistoryType = $event"
          cachename="ordre"
        ></app-select-filter>
      } @else {
        @if (
          serviceordre.serviceordreStateEnum == serviceordreStatusEnum.Broadcasted ||
          serviceordre.serviceordreStateEnum == serviceordreStatusEnum.CompletedWithAccounting ||
          serviceordre.serviceordreStateEnum == serviceordreStatusEnum.CompletedWithRejection ||
          serviceordre.serviceordreStateEnum == serviceordreStatusEnum.Created
          ) {
          <button
            class="btn-icon align-center"
            type="button"
            (click)="ChangeOrderType(serviceordre)"
            [disabled]="!isAdmin && !isSuperUser"
            matTooltip="Skift ordrens type"
            >
            <mat-icon svgIcon="edit"></mat-icon>
            <span>Skift type</span>
          </button>
        }
        @if (serviceOrdreAfregning != null && serviceOrdreAfregning.partnerPayload != null) {
          <button
            class="btn-icon align-center"
            type="button"
            (click)="showPartnerPayload(serviceOrdreAfregning.partnerPayload, serviceOrdreAfregning.receivedDate)"
            matTooltip="Vis rå data fra partner"
            >
            <mat-icon svgIcon="table"></mat-icon>
            <span>Vis partnerdata</span>
          </button>
        }
        @if (
          serviceordre.serviceordreStateEnum == serviceordreStatusEnum.Broadcasted ||
          serviceordre.serviceordreStateEnum == serviceordreStatusEnum.ReadyForBroadcast ||
          serviceordre.serviceordreStateEnum == serviceordreStatusEnum.BroadcastFailed
          ) {
          <button
            class="btn-icon align-center"
            type="button"
            (click)="GensendOrdre(serviceordre)"
            matTooltip="Gensend ordren"
            >
            <mat-icon svgIcon="redo"></mat-icon>
            <span>Gensend ordren</span>
          </button>
        }
        @if (CanCancel && hasRights) {
          <button
            class="btn-icon red-cancel align-center"
            type="button"
            (click)="CancelOrdre(serviceordre)"
            [disabled]="!canWrite"
            matTooltip="Annuller ordre"
            >
            <mat-icon svgIcon="delete"></mat-icon>
            <span>Annuller ordre</span>
          </button>
        }
        @if (serviceordre.serviceordreStateEnum == serviceordreStatusEnum.CompletedWithAccounting) {
          <button
            class="btn-icon red-cancel align-center"
            type="button"
            matTooltip="Afvis posteringer"
            (click)="rejectPosteringer()"
            [disabled]="!this.canCancelPosteringer"
            >
            <mat-icon svgIcon="delete"></mat-icon>
            <span>Afvis posteringer</span>
          </button>
        }
        @if (serviceordre.serviceordreStateEnum == serviceordreStatusEnum.CompletedWithRejection) {
          <button
            mat-raised-button
            color="accent"
            class="btn btn-trans mat-elevation-z0"
            type="button"
            matTooltip="Genfremsend ordre"
            [disabled]="!canWrite"
            (click)="resendOrdre()"
            >
            Genfremsend ordre
          </button>
        }
        @if (serviceordre.serviceordreStateEnum == serviceordreStatusEnum.InvoicingFailed) {
          <button
            mat-raised-button
            color="primary"
            class="mat-elevation-z0"
            (click)="RequeueOrdreForAccounting(serviceordre)"
            >
            Forsøg afregning igen
          </button>
        }
        @if (
          serviceordre.serviceordreStateEnum == serviceordreStatusEnum.CompletedWithAccounting ||
          serviceordre.serviceordreStateEnum == serviceordreStatusEnum.Parked
          ) {
          <button
            mat-raised-button
            color="primary"
            class="mat-elevation-z0"
            (click)="ApproveOrdre(serviceordre)"
            [disabled]="!canGodkendePosteringer"
            >
            Godkend posteringer
          </button>
        }
        @if (serviceordre.serviceordreStateEnum == serviceordreStatusEnum.ApprovedForInvoicing) {
          <button
            mat-raised-button
            color="accent"
            class="mat-elevation-z0"
            (click)="RetractApproval(serviceordre)"
            [disabled]="!canGodkendePosteringer"
            >
            Fortryd godkendelse
          </button>
        }
      }
    </div>
  </div>
  <div class="page__content page__content--has-submenu order order--details">
    <ng-container>
      @if (page == 'Detaljer') {
        <app-edit-ordre-details
          [serviceordreWithAfregning]="serviceordreWithAfregning"
          (UpdateOrder)="UpdateOrdre($event)"
          [serviceAftale]="serviceAftale"
        ></app-edit-ordre-details>
      }
      @if (page == 'Historik') {
        <app-history
          [entityId]="serviceordre.id"
          [entityType]="entityType"
          [auditHistoryTypeFilter]="selectedAuditHistoryType"
        ></app-history>
      }
      @if (page == 'Rapporter') {
        <app-rapporter
          [rapporter]="serviceordre.rapporter"
          [serviceOrdreNo]="serviceordre.serviceordreNo"
        ></app-rapporter>
      }
    </ng-container>
  </div>
  @if (!quickViewOpen) {
    <div class="bottombar bottombar--has-submenu">
      <div class="bottombar__details">
        <strong>Aftale</strong>
        <span>#{{ serviceAftale?.okKundeAftaleNr }}</span>
        <span class="sep">|</span>
        <span>{{ serviceAftale?.serviceAbonnement?.description }}</span>
        <span class="sep">|</span>
        @for (valg of serviceAftale?.tilvalg; track valg) {
          <span>{{ valg.name }}</span>
        }
        <span class="sep">|</span>
        <a [routerLink]="['/aftale/', $safeNavigationMigration(serviceAftale?.okKundeAftaleNr)]" fragment="Ordrer">
          @if (serviceordrer.length <= 1) {
            <span>Ingen andre ordre lige nu</span>
          }
          @if (serviceordrer.length == 2) {
            <span>1 anden ordre lige nu</span>
          }
          @if (serviceordrer.length > 2) {
            <span>{{ serviceordrer.length - 1 }} andre ordre lige nu</span>
          }
        </a>
      </div>
      <div class="bottombar__actions">
        <a (click)="visAftale()" matTooltip="Vis aftalen" class="btn-icon blue">Vis aftalen</a>
      </div>
    </div>
  }
  @if (quickViewOpen) {
    <div class="quick-view" [@inOutAnimation]>
      <button type="button" class="btn-icon btn-close" (click)="closeQuickView()" title="Luk">
        <mat-icon>close</mat-icon>
      </button>
      <app-quickview [serviceaftale]="serviceAftale"></app-quickview>
      <div class="quick-view__bottom">
        <app-opfoelgning-action
          [entityNo]="serviceAftale.serviceAftaleNo"
          [opfoelgningList]="serviceAftale.opfoelgningList"
          (opfoelgningChange)="onAftaleOpfoelgningChanged($event)"
          offset-class="opfoelgning-bookmark-count__quickview"
        ></app-opfoelgning-action>
        <button mat-raised-button color="primary" [routerLink]="['/aftale', serviceAftale.okKundeAftaleNr]">Åben aftalen</button>
      </div>
    </div>
  }
}
